import { Box, Divider, List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import React from 'react';

const ResourceRules: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Resource Usage Guidelines
            </Typography>
            <Paper sx={{ p: 3 }}>
                <Typography variant="body1" paragraph>
                    These guidelines define the proper and fair usage of shared corporate resources. By creating a reservation you agree to follow the rules below. Violations may result in suspension of reservation privileges.
                </Typography>
                <Divider sx={{ my: 2 }} />
                <List sx={{ listStyleType: 'decimal', pl: 3 }}>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Reserve only what you need. Avoid booking large time blocks you cannot fully use." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Be punctual. Repeated no‑shows or late starts reduce availability for others." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Cancel early if plans change so others may take the slot." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Leave the resource in equal or better condition (clean surfaces, return accessories, power down if appropriate)." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Report damage or technical issues immediately via the support channel or IT ticket." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Do not transfer reservations without explicit approval (create a new reservation instead)." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Sensitive or confidential materials must be removed when you are finished." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Shared credentials, licenses, or specialized equipment must not be copied or removed from the premises." />
                    </ListItem>
                    <ListItem sx={{ display: 'list-item' }}>
                        <ListItemText primary="Abuse (e.g., monopolizing peak hours) may trigger manual review or temporary limits." />
                    </ListItem>
                </List>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h6" gutterBottom>
                    Reservation Etiquette
                </Typography>
                <Typography variant="body2" paragraph>
                    For back‑to‑back bookings, schedule a short gap (5–10 minutes) to allow setup/cleanup. If you finish early, release the resource by canceling. For occupied but unclaimed resources beyond a grace period (typically 10 minutes), admins may reassign.
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Enforcement
                </Typography>
                <Typography variant="body2" paragraph>
                    Multiple violations (no‑shows, damage, misuse) may escalate from warnings to temporary suspension or permanent restriction. Serious incidents will be reviewed by administration.
                </Typography>
                <Typography variant="caption" display="block" color="text.secondary">
                    Last updated: {new Date().toLocaleDateString()}
                </Typography>
            </Paper>
        </Box>
    );
};

export default ResourceRules;
